import React from 'react';
import { TextCardBox } from './styled';

function TextCard(props) {

    const title = props.title;
    const content = props.content;

    const business_kor = props.business_kor;
    const business_eng = props.business_eng;

    return (
        <TextCardBox inline={props.inline} maxWidth={props.maxWidth}>

            { props.title !== undefined ?
                <div>
                    <div className="title">{title}</div>
                    <br />
                    <div className="content">{content}</div>
                </div>
            : null }

            { props.business_kor !== undefined ?
                <div>
                    <div className="business_kor">{business_kor}</div>
                    <br />
                    <div className="business_eng">{business_eng}</div>
                </div>
            : null }
            
        </TextCardBox>
    );
}

export default TextCard;